module.exports = __webpack_public_path__ + "img/edit-avatar.645e59b1.svg";